import React, {ReactNode, useEffect, useImperativeHandle, useState} from 'react';
import {Button, Col, Form, FormInstance, Row} from 'antd';

export type FilterColumn = {
  title: string;
  key?: string;
  dataIndex: string;
  span?: number;
  require?: boolean;
  render: (form: FormInstance<any>) => ReactNode;
};

export type ButtonColumn = {
  title: string;
  key?: string;
  doClick?: (params: any, exParams?: any) => void;
  onClick?: (params: any, exParams?: any) => Promise<void>;
};

export type GridFilterFormProps = {
  columns: FilterColumn[];
  buttonColumns?: ButtonColumn[];
  doSearch: (params: any, exParams?: any) => void;
  reLoadKey?: Number;
  // 额外参数，主要用于按钮查询获取
  params?: any;
  initialValues?: any;
  ref?: any;
};

type CellFilterColumn = {
  offset: number;
  span: number;
  key: string;
  column: FilterColumn;
}

const GridFilterForm: React.FC<GridFilterFormProps> = React.forwardRef(
  (props, ref) => {
  const [form] = Form.useForm();
  const [columns, setColumns] = useState<CellFilterColumn[]>([]);
  const [buttonOffset, setButtonOffset] = useState(0);
  const [loading, setLoading] = useState(false);


  useImperativeHandle(ref, () => {
    return {
      getForm: ()=>form
    }
  })

  const formatRows = (columns: FilterColumn[]) => {
    const items: CellFilterColumn[] = [];
    let totalSpan = 0;
    const const_Total_Span = 24;
    (columns ? columns : []).forEach(function (column, itemIndex) {
      const span = column.span ? column.span : 4;
      if (totalSpan + span > const_Total_Span) {
        totalSpan = 0;
      }
      totalSpan += span;
      const key = column.key ? column.key : column.dataIndex;
      items.push({column: column, offset: 0, span: span, key});
    });

    if (props?.buttonColumns && props?.buttonColumns.length > 1) {
      if (totalSpan + 8 > const_Total_Span) {
        totalSpan = 0;
      }
      setButtonOffset(const_Total_Span - 8 - totalSpan);
    } else {
      if (totalSpan + 4 > const_Total_Span) {
        totalSpan = 0;
      }
      setButtonOffset(const_Total_Span - 4 - totalSpan);
    }
    return items;
  };

  const onSearch = () => {
    form.validateFields().then(() => {
      setLoading(true);
      props.doSearch(form.getFieldsValue(), props.params);
      setLoading(false);
    });
  };

  useEffect(() => {
    setColumns(formatRows(props.columns));
  }, [props.columns]);

  useEffect(() => {
    if (props.initialValues) {
      for (const key in props.initialValues) {
        if (props.initialValues[key]) {
          form.setFieldsValue({
            [key]: props.initialValues[key]
          });
        }
      }
    }
  }, [props.initialValues]);

  useEffect(() => {
    form.resetFields();
  }, [props.reLoadKey]);

  return (
    <Form form={form} layout="vertical">
      {
        (props.columns.length > 0) &&
        <Row gutter={[10, 0]}>
          {
            columns.map((row) => (
              <Col span={row.span} offset={row.offset} key={row.key}>
                {
                  <Form.Item
                    label={row.column.title}
                    name={row.column.dataIndex}
                    style={{marginBottom: "5px"}}
                    rules={[{required: row.column.require || false}]}
                  >
                    {row.column.render(form)}
                  </Form.Item>
                }
              </Col>
            ))
          }
          <Col span={2} offset={buttonOffset + (props?.buttonColumns && props?.buttonColumns.length > 0 ? 0 : 2)}
               key="_grid_button">
            <div style={{marginBottom: "5px", float: 'right'}}>
              <Button
                style={(buttonOffset == 20 || (props?.buttonColumns && props?.buttonColumns.length > 1 && buttonOffset == 16)) ? {} : {bottom: '-30px'}}
                type="primary" onClick={onSearch} loading={loading}>搜索</Button>
            </div>
          </Col>
          {props?.buttonColumns && props?.buttonColumns.length > 0 &&
          props.buttonColumns.map((row, index) => (
            <Col span={2} key={"_grid_button_" + index}>
              <div style={{marginBottom: "5px", float: 'right'}}>
                <Button
                  key={row.key}
                  type="primary"
                  loading={loading}
                  onClick={() => {
                    form.validateFields().then(() => {
                      if (row.onClick) {
                        setLoading(true);
                        row.onClick(form.getFieldsValue(), props.params).then(() => {
                          setLoading(false);
                        })
                      } else {
                        row.doClick?.(form.getFieldsValue(), props.params)
                      }
                    });
                  }}
                  style={(buttonOffset == 20 || (props?.buttonColumns && props?.buttonColumns.length > 1 && buttonOffset == 16)) ? {} : {bottom: '-30px'}}
                >{row.title}</Button>
              </div>
            </Col>
          ))
          }
        </Row>
      }
    </Form>
  );
  })

export {GridFilterForm};


